/* eslint-disable @typescript-eslint/no-explicit-any */
import { APIModel } from './api-model.model'

export class APIWidget extends APIModel {
    widgetId: number;
    widgetTitle: string;
    widgetEnabled: number;
    widgetPriority: number;
    widgetDefaultWidth: number;
    widgetDefaultWidgetChartId: any;
    providerId: number;
    reportId: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        widgetId: number;
        widgetTitle: string;
        widgetEnabled: number;
        widgetPriority: number;
        widgetDefaultWidth: number;
        widgetDefaultWidgetChartId: number;
        providerId: number;
        reportId: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.widgetId = params.widgetId
        this.widgetTitle = params.widgetTitle
        this.widgetEnabled = params.widgetEnabled ? 1 : 0
        this.widgetPriority = params.widgetPriority
        this.widgetDefaultWidth = params.widgetDefaultWidth
        this.widgetDefaultWidgetChartId = params.widgetDefaultWidgetChartId
        this.providerId = params.providerId
        this.reportId = params.reportId
    }
}
